import React from 'react'
import '../../styles/Login.css'
import AppInputText from '../../ui/AppInputText'
import AppButton from '../../ui/AppButton'
import Grid from '@material-ui/core/Grid';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import AppToast from '../../ui/AppToast'
import Api from '../../helpers/Api'
import Env from '../../config/env'
import ValidateForm from '../../helpers/ValidateForm'
import GetDataApi from '../../helpers/GetDataApi'
import Session from '../../helpers/Session';
import Redirect from "../../helpers/Redirect";
import {Link} from "react-router-dom";
import Avatar from "@material-ui/core/Avatar";
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Colors from "../../config/colors";
import Header from "../../components/Header";
import Alert from "@material-ui/lab/Alert";
import GooglePlayIcon from '../../assets/google-play.png'
import AppStoreIcon from '../../assets/app-store.png'
import AppInputPasswordView from "../../ui/AppInputPasswordView";
import {withRouter} from 'react-router';

class Login extends React.Component {


    constructor(props) {
        super(props);

        this.state = {
            form: {
                email: {
                    key: 'email',
                    value: '',
                    required: true
                },
                password: {
                    key: 'password',
                    value: '',
                    required: true
                },
            },
            url: '',
        };

        this.handleSubmit = this.handleSubmit.bind(this);
    }

    handleSubmit = async (e) => {
        e.preventDefault();

        if (!ValidateForm(this.state.form)) {
            return;
        }

        let params = GetDataApi(this.state.form);
        const data = await Api.get(`${Env.UrlSeguridad}/getLogin/${encodeURIComponent(params.email)}/${encodeURIComponent(params.password)}`,);
        if (data.cod === '1') {
            Session.login(data.tercero);

            // Si hay guardada alguna redireccion luego de loguear
            const redirectTo = Session.getRedirectTo();
            if (redirectTo) {
                this.setState({
                    url: redirectTo
                });
            } else { // Si no por defecto redirecciona al listado de cuentas
                this.setState({
                    url: '/accounts'
                });
            }

        } else {
            AppToast(data.msg, data.cod);
        }
    }

    handleChange = (e) => {
        const {value, name} = e.target;

        this.setState((statePrev) => {
            return {
                form: {
                    ...statePrev.form,
                    [name]: {
                        ...statePrev.form[name],
                        value: value
                    }
                }
            }

        });
    }

    render() {
        return (
            <div>
                <Redirect url={this.state.url}/>

                <Header/>

                <form onSubmit={this.handleSubmit}>
                    <Grid
                        container
                        direction="column"
                        justify="flex-start"
                        alignItems="center">

                        <Card className='container-login'>

                            <Avatar style={{background: Colors.accent, marginLeft: '45%'}}>
                                <LockOutlinedIcon/>
                            </Avatar>

                            <CardHeader title="Iniciar Sesión"/>

                            <Grid item xs={12} className='grid-item'>
                                <AppInputText
                                    id={this.state.form.email.key}
                                    name={this.state.form.email.key}
                                    value={this.state.form.email.value}
                                    label='Ingrese el email'
                                    onChange={this.handleChange}
                                    required={this.state.form.email.required}
                                />
                            </Grid>
                            <Grid item xs={12} className='grid-item'>

                                <AppInputPasswordView
                                    id={this.state.form.password.key}
                                    name={this.state.form.password.key}
                                    value={this.state.form.password.value}
                                    label='Ingrese la contraseña'
                                    onChange={this.handleChange}
                                    required={this.state.form.password.required}
                                    labelWidth={170}
                                />

                            </Grid>
                            <Grid item xs={12} className='grid-item'>
                                <AppButton
                                    type='submit'
                                    label='Ingresar'
                                    size='large'
                                    customStyles={{width: '100%', height: '50px'}}
                                />
                            </Grid>

                            <Grid item xs={12} className='grid-item'>
                                <Alert severity="info">
                                    Recuerda que puedes ingresar con el mismo usuario y contraseña que registraste en la
                                    app movil
                                </Alert>
                                <div style={{textAlign: 'center', paddingTop: '10px'}}>
                                    <span>Descarga nuestra App!</span><br/>
                                    <a href={Env.UrlAppAndroid} style={{paddingRight: '10px'}} target='_blank'
                                       rel="noopener noreferrer">
                                        <img style={{width: '50px'}} src={GooglePlayIcon} alt='Logo Google Play'/>
                                    </a>
                                    <a href={Env.UrlAppIos} style={{paddingLeft: '10px'}} target='_blank'
                                       rel="noopener noreferrer">
                                        <img style={{width: '50px'}} src={AppStoreIcon} alt='Logo AppStore'/>
                                    </a>
                                </div>
                            </Grid>

                            <Grid container spacing={2} style={{paddingTop: '20px', paddingBottom: '20px'}}>
                                <Grid item xs={12} sm={6} className='grid-item'>
                                    <Link to='/recover-password' variant="body2">
                                        {"¿Olvidó su contraseña?"}
                                    </Link>
                                </Grid>

                                <Grid item xs={12} sm={6} className='grid-item'>
                                    ¿No tienes una cuenta?
                                    <Link to='/signup' variant="body2">
                                        {" Regístrate"}
                                    </Link>
                                </Grid>

                            </Grid>

                        </Card>
                    </Grid>
                </form>
            </div>
        );
    }

}

export default withRouter(Login)

